import { render, staticRenderFns } from "./StationWaterQualityTabular.vue?vue&type=template&id=41927c92&scoped=true"
import script from "./StationWaterQualityTabular.vue?vue&type=script&lang=js"
export * from "./StationWaterQualityTabular.vue?vue&type=script&lang=js"
import style0 from "./StationWaterQualityTabular.vue?vue&type=style&index=0&id=41927c92&prod&lang=css"
import style1 from "./StationWaterQualityTabular.vue?vue&type=style&index=1&id=41927c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41927c92",
  null
  
)

export default component.exports